import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  fetchPostedProducts,
  fetchAllProductInteractionCounts,
} from "../../services/BuildingMaterials";
import { getAllProductsByCategory } from "../../services/productServices";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Spinner from "../shared/Spinner";

// Register chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function PostViewRatioByProduct() {
  const [ratioData, setRatioData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const categoryName = "Building Materials / የግንባታ እቃዎች";
        const categoryProducts = await getAllProductsByCategory(categoryName);
        const productList = (categoryProducts || []).map((p, index) => ({
          name: p.name,
          index,
        }));

        const postedProducts = await fetchPostedProducts();
        const interactionCounts = await fetchAllProductInteractionCounts();

        const postCounts = productList.reduce((acc, { name }) => {
          acc[name] = 0;
          return acc;
        }, {});
        const viewCounts = productList.reduce((acc, { name }) => {
          acc[name] = 0;
          return acc;
        }, {});

        Object.values(postedProducts).forEach((category) => {
          category.total.forEach((offer) => {
            const productName = offer.product_name;
            if (productName && postCounts[productName] !== undefined) {
              postCounts[productName] += 1;
            }
          });
        });

        Object.values(interactionCounts).forEach((counts) => {
          counts.forEach(({ product_name, interactionCount }) => {
            if (product_name && viewCounts[product_name] !== undefined) {
              viewCounts[product_name] += interactionCount;
            }
          });
        });

        const ratioData = productList
          .map(({ name, index }) => {
            const postCount = postCounts[name] || 0;
            const viewCount = viewCounts[name] || 0;
            const ratio = postCount > 0 ? viewCount / postCount : 0;
            return { productName: name, ratio, index };
          })
          .sort((a, b) =>
            b.ratio === a.ratio ? a.index - b.index : b.ratio - a.ratio
          );

        const chartData = {
          labels: ratioData.map((item) => item.productName),
          datasets: [
            {
              label: "View-to-Post Ratio",
              data: ratioData.map((item) => item.ratio),
              backgroundColor: "rgba(75, 192, 192, 0.8)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        };

        setRatioData(chartData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "View-to-Post Ratio by Product",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Product Names",
        },
      },
      y: {
        title: {
          display: true,
          text: "View-to-Post Ratio",
        },
        beginAtZero: true,
      },
    },
    plugins: {
      // Configure data labels
      datalabels: {
        anchor: "end",
        align: "end",
        formatter: (value) => value.toFixed(2), // Format the value to 2 decimal places
        color: "#000", // Color of the text
        font: {
          weight: "bold",
        },
      },
    },
  };

  return (
    <div style={{ height: "300px", position: "relative" }}>
      {ratioData ? <Bar data={ratioData} options={options} /> : (
        <div className="relative min-h-[300px] flex items-center justify-center">
          <Spinner size="xl" fullScreen={true} />
        </div>
      )}
    </div>
  );
}

export default PostViewRatioByProduct;
